import React from 'react';
import styles from './Modal.module.scss';

const ModalErrorMessage = ({ show, message, className }) => {
  if (show) {
    return (
      <p className={`${styles.error_message} ${className || ''}`}>{message}</p>
    );
  }
  return null;
};

export default ModalErrorMessage;
